import React, { useEffect, useState } from 'react'

const BeforeAfterSlider = ({ beforeImage, afterImage, containerRef }) => {
	const [position, setPosition] = useState(50)
	const [isDragging, setIsDragging] = useState(false)
	const [size, setSize] = useState({ width: 0, height: 0 })

	const startDragging = () => setIsDragging(true)
	const stopDragging = () => setIsDragging(false)

	const updateSize = () => {
		if (containerRef?.current) {
			const { width, height } = containerRef.current.getBoundingClientRect()
			setSize({ width, height })
		}
	}

	const handleMove = e => {
		if (!isDragging) return
		const clientX = e.touches ? e.touches[0].clientX : e.clientX
		const bounds = containerRef.current.getBoundingClientRect()
		const offset = ((clientX - bounds.left) / bounds.width) * 100
		setPosition(Math.max(0, Math.min(100, offset)))
	}

	useEffect(() => {
		updateSize()
		window.addEventListener('resize', updateSize)
		return () => window.removeEventListener('resize', updateSize)
	}, [])

	document.onmousemove = handleMove
	document.ontouchmove = handleMove
	document.onmouseup = stopDragging
	document.ontouchend = stopDragging


	return (
		<div
			ref={containerRef}
			className='relative overflow-hidden select-none touch-none border-[3.67px] border-solid border-black rounded-[50px]'
			style={{ width: `${size.width}px`, height: `${size.height}px` }}
			onMouseDown={startDragging}
			onTouchStart={startDragging}>
			<img
				src={afterImage}
				alt='after'
				className='absolute inset-0 object-cover mt-5'
				style={{ minWidth: `${size.width}px`, minHeight: `${size.height}px` }}
				draggable={false}
			/>

			<div
				className='absolute inset-0 overflow-hidden'
				style={{ width: `${position}%`, height: '100%' }}>
				<img
					src={beforeImage}
					alt='before'
					className={`absolute inset-0 object-cover mt-5`}
					style={{
						minWidth: `${size.width}px`,
						minHeight: `${size.height}px`,
					}}
					draggable={false}
				/>
			</div>

			<div className='absolute top-6 left-8 text-white text-sm bg-black/50 px-4 py-1 rounded'>
				До
			</div>
			<div className='absolute top-6 right-8 text-white text-sm bg-black/50 px-4 py-1 rounded'>
				После
			</div>

			<div
				className='absolute top-0 bottom-0 z-10 w-1 bg-white shadow cursor-ew-resize'
				style={{ left: `${position}%`, transform: 'translateX(-50%)' }}
				onMouseDown={startDragging}
				onTouchStart={startDragging}>
				<div className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-full p-1 shadow'>
					<div className='w-4 h-4 bg-gray-800 rounded-full' />
				</div>
			</div>
		</div>
	)
}

export default BeforeAfterSlider
